import { ComponentTopSpenderOrderList } from "src/Components/TopSpender/OrderList";
import { selectAuth } from "@redux";
import { useSelector } from "react-redux";

export const PageTopSpenderOrderList = () => {
    const { userInfo } = useSelector(selectAuth);

    return <ComponentTopSpenderOrderList userInfo={userInfo} />;
};
